export const programNormalColDefs = [
    {
        headerName: '연도',
        field: 'year',
        filter: true,
    },
    {
        headerName: '지역',
        field: 'region',
        filter: true,
    },
    {
        headerName: '교육신청자수',
        field: 'edu_applicants',
    },
    {
        headerName: '교육수혜자수',
        field: 'edu_beneficiaries',
    },
    {
        headerName: '수혜율',
        field: 'benefit_ratio',
        cellRenderer: params => {
            return params.value ? `${params.value}%` : ''
        },
    },
    {
        headerName: '소속학교',
        children: [
            {
                headerName: '초등학교',
                field: 'elem_school',
            },
            {
                headerName: '중학교',
                field: 'mid_school',
            },
            {
                headerName: '고등학교',
                field: 'high_school',
            },
            {
                headerName: '특수학교',
                field: 'spec_school',
            },
        ],
    },
    {
        headerName: '성별',
        children: [
            {
                headerName: '남성',
                field: 'male',
            },
            {
                headerName: '여성',
                field: 'female',
            },
        ],
    },
    {
        headerName: '지역구분',
        children: [
            {
                headerName: '미래채움센터 유',
                field: 'future_center_yes',
            },
            {
                headerName: '미래채움센터 무',
                field: 'future_center_no',
            },
        ],
    },
    {
        headerName: '수혜대상구분',
        children: [
            {
                headerName: '일반학생',
                field: 'reg_students',
            },
            {
                headerName: '소외계층',
                field: 'underprivileged',
            },
        ],
    },
    {
        headerName: '수혜기관 구분(학생의 소속 기준)',
        children: [
            {
                headerName: '일반학교',
                field: 'reg_schools',
            },
            {
                headerName: '도서벽지학교',
                field: 'book_walls_schools',
            },
            {
                headerName: '특수학교 (장애학교, 대안학교 등)',
                field: 'special_disability_schools',
            },
            {
                headerName: '기관 (아동복지센터 등)',
                field: 'child_welfare_institutions',
            },
        ],
    },
    {
        headerName: '수혜기관 구분(교육횟수 기준)',
        children: [
            {
                headerName: '센터내교육',
                field: 'within_center',
            },
            {
                headerName: '찾아가는교육',
                children: [
                    { headerName: '일반학교', field: 'reg_schools' },
                    {
                        headerName: '도서벽지학교',
                        field: 'book_walls_schools',
                    },
                    {
                        headerName: '특수학교 (장애학교, 대안학교 등)',
                        field: 'special_disability_schools',
                    },
                    {
                        headerName: '기관 (아동복지센터 등)',
                        field: 'child_welfare_institutions',
                    },
                ],
            },
        ],
    },
    {
        headerName: '교육시간',
        children: [
            {
                headerName: '단기교육',
                children: [
                    { headerName: '1~2시간', field: 'hour_1to2' },
                    { headerName: '3~8시간 미만', field: 'hour_3to8' },
                ],
            },
            {
                headerName: '중기교육',
                children: [
                    { headerName: '8~30시간 미만', field: 'hour_8to30' },
                    { headerName: '30~50시간 미만', field: 'hour_30to50' },
                ],
            },
            { headerName: '장기교육', children: [{ headerName: '50시간 이상', field: 'more50_hours' }] },
        ],
    },
    {
        headerName: '교육방법',
        children: [
            { headerName: '온라인', field: 'online' },
            { headerName: '오프라인', field: 'offline' },
        ],
    },
    {
        headerName: '교육유형',
        children: [
            { headerName: '센터내교육', field: 'within_center' },
            { headerName: '찾아가는교육', field: 'outreach_edu' },
            { headerName: '기타', field: 'other' },
        ],
    },
]

export const programPivotColDefs = [
    {
        headerName: '연도',
        field: 'year',
        rowGroup: true,
    },
    {
        headerName: '지역',
        field: 'region',
    },
    {
        headerName: '교육신청자수',
        field: 'edu_applicants',
    },
    {
        headerName: '교육수혜자수',
        field: 'edu_beneficiaries',
    },
    {
        headerName: '수혜율',
        field: 'benefit_ratio',
        cellRenderer: params => {
            return params.value ? `${params.value}%` : ''
        },
    },
    {
        headerName: '초등학교',
        field: 'elem_school',
    },
    {
        headerName: '중학교',
        field: 'mid_school',
    },
    {
        headerName: '고등학교',
        field: 'high_school',
    },
    {
        headerName: '특수학교',
        field: 'spec_school',
    },
    {
        headerName: '남성',
        field: 'male',
    },
    {
        headerName: '여성',
        field: 'female',
    },
    {
        headerName: '미래채움센터 有',
        field: 'future_center_yes',
    },
    {
        headerName: '미래채움센터 無',
        field: 'future_center_no',
    },
    {
        headerName: '일반학생',
        field: 'reg_students',
    },
    {
        headerName: '소외계층',
        field: 'underprivileged',
    },
    {
        headerName: '일반학교',
        field: 'reg_schools',
    },
    {
        headerName: '도서벽지학교',
        field: 'book_walls_schools',
    },
    {
        headerName: '특수학교 (장애학교, 대안학교 등)',
        field: 'special_disability_schools',
    },
    {
        headerName: '기관 (아동복지센터 등)',
        field: 'child_welfare_institutions',
    },
    { headerName: '1~2시간', field: 'hour_1to2' },
    {
        headerName: '3~8시간 미만',
        field: 'hour_3to8',
    },
    {
        headerName: '8~30시간 미만',
        field: 'hour_8to30',
    },
    {
        headerName: '30~50시간 미만',
        field: 'hour_30to50',
    },
    {
        headerName: '50시간 이상',
        field: 'more50_hours',
    },
    {
        headerName: '온라인',
        field: 'online',
    },
    {
        headerName: '오프라인',
        field: 'offline',
    },
    {
        headerName: '센터내교육',
        field: 'within_center',
    },
    {
        headerName: '찾아가는교육',
        field: 'outreach_edu',
    },
    {
        headerName: '기타',
        field: 'other',
    },
]

export const tutorsNormalColDefs = [
    {
        headerName: '연도',
        field: 'year',
        filter: true,
    },
    {
        headerName: '지역',
        field: 'region',
        filter: true,
    },
    {
        headerName: '목표',
        field: 'goal',
    },
    {
        headerName: '실적 (연말기준 채용인원)',
        field: 'hired_count',
    },
    {
        headerName: '목표 대비 달성율',
        field: 'hired_ratio',
    },
    {
        headerName: '이탈인원 포함 합계',
        field: 'total_with_fail',
    },
    {
        headerName: '강사구분',
        children: [
            {
                headerName: '신규강사',
                field: 'new_employee',
            },
            {
                headerName: '재고용강사',
                field: 'reemployee',
            },
        ],
    },
    {
        headerName: '우선순위 미적용',
        children: [
            { headerName: '청년(35세 미만)', field: 'youth' },
            { headerName: '경력단절여성', field: 'career_stop_woman' },
            { headerName: '경력단절여성(재고용강사 채용시 기준)', field: 'career_stop_woman_reemployee' },
            { headerName: '퇴직전문가', field: 'retired_expert' },
            { headerName: '기타', field: 'etc' },
            { headerName: '중복인원', field: 'duplicate_person' },
        ],
    },
    {
        headerName: '우선순위 적용',
        children: [
            { headerName: '청년(35세 미만) <1순위>', field: 'youth' },
            { headerName: '경력단절여성(재고용강사 채용시 기준) <2순위>', field: 'career_stop_woman_reemployee' },
            { headerName: '퇴직전문가 <3순위>', field: 'retired_expert' },
            { headerName: '기타 <4순위>', field: 'etc' },
        ],
    },
    {
        headerName: '연령기준 (만 나이 기준)',
        children: [
            { headerName: '20~29세', field: 'age_20s' },
            { headerName: '30~39세', field: 'age_30s' },
            { headerName: '40~49세', field: 'age_40s' },
            { headerName: '50대이상', field: 'age_over_50' },
        ],
    },
    {
        headerName: '성별',
        children: [
            { headerName: '남성', field: 'male' },
            { headerName: '여성', field: 'female' },
        ],
    },
    {
        headerName: '창업(사업자등록완료)',
        children: [{ headerName: '사업자등록완료', field: 'own_bussiness' }],
    },
    {
        headerName: '고용형태',
        children: [
            { headerName: '정규직', field: 'full_time_contract' },
            { headerName: '계약직', field: 'contract_worker' },
        ],
    },
    {
        headerName: '근로시간',
        children: [
            { headerName: '주 40시간 이상', field: 'over_40_week' },
            { headerName: '주 15 ~ 39시간', field: 'work_15to39_week' },
            { headerName: '주 15시간 미만', field: 'under_15_week' },
        ],
    },
    {
        headerName: '4대보험 가입률',
        children: [
            { headerName: '전부가입', field: 'full_insurance' },
            { headerName: '일부가입', field: 'partial_insurance' },
            { headerName: '미가입', field: 'no_insurance' },
        ],
    },
    {
        headerName: '계약기간',
        children: [
            { headerName: '정규직(무기계약직)', field: 'indefine_contract' },
            { headerName: '21개월~30개월(2차 재고용)', field: 'secondary_recontract' },
            { headerName: '11개월~20개월(1차 재고용)', field: 'first_recontract' },
            { headerName: '10개월 이내(최초고용)', field: 'first_contract' },
        ],
    },
    {
        headerName: 'ICTSW관련전공여부',
        children: [
            { headerName: '해당없음', field: 'ictswN' },
            { headerName: '해당', field: 'ictswY' },
        ],
    },
    {
        headerName: '전공구분',
        children: [
            { headerName: '인문과학', field: 'humanity_major' },
            { headerName: '사회과학', field: 'social_science_major' },
            { headerName: '자연과학', field: 'natural_science_major' },
            { headerName: '공학', field: 'tech_major' },
            { headerName: '예체능', field: 'art_major' },
            { headerName: '기타', field: 'etc_major' },
        ],
    },
    {
        headerName: 'SW강의경험',
        children: [
            { headerName: '없음', field: 'no_sw_experience' },
            { headerName: '1년 미만', field: 'sw_experience_under_year' },
            { headerName: '1년이상 3년미만', field: 'sw_experience_one_to_three' },
            { headerName: '3년이상', field: 'sw_experience_over_three' },
        ],
    },
    {
        headerName: '기타강의경험',
        children: [
            { headerName: '없음', field: 'no_lec_experience' },
            { headerName: '1년 미만', field: 'lec_experience_under_year' },
            { headerName: '1년이상 3년미만', field: 'lec_experience_one_to_three' },
            { headerName: '3년이상', field: 'lec_experience_over_three' },
        ],
    },
    {
        headerName: '강사 평균 임금(월)',
        field: 'average_wage',
    },
]

export const tutorsPivotColDefs = [
    {
        headerName: '연도',
        field: 'year',
    },
    {
        headerName: '지역',
        field: 'region',
    },
    {
        headerName: '목표',
        field: 'goal',
    },
    {
        headerName: '실적 (연말기준 채용인원)',
        field: 'hired_count',
    },
    {
        headerName: '목표 대비 달성율',
        field: 'hired_ratio',
    },
    {
        headerName: '이탈인원 포함 합계',
        field: 'total_with_fail',
    },
    {
        headerName: '신규강사',
        field: 'new_employee',
    },
    {
        headerName: '재고용강사',
        field: 'reemployee',
    },
    { headerName: '(우선순위 미적용) 청년(35세 미만)', field: 'youth' },
    { headerName: '(우선순위 미적용) 경력단절여성', field: 'career_stop_woman' },
    { headerName: '(우선순위 미적용) 경력단절여성(재고용강사 채용시 기준)', field: 'career_stop_woman_reemployee' },
    { headerName: '(우선순위 미적용) 퇴직전문가', field: 'retired_expert' },
    { headerName: '(우선순위 미적용) 기타', field: 'etc' },
    { headerName: '(우선순위 미적용) 중복인원', field: 'duplicate_person' },
    { headerName: '(우선순위 적용) 청년(35세 미만) <1순위>', field: 'youth' },
    {
        headerName: '(우선순위 적용) 경력단절여성(재고용강사 채용시 기준) <2순위>',
        field: 'career_stop_woman_reemployee',
    },
    { headerName: '(우선순위 적용) 퇴직전문가 <3순위>', field: 'retired_expert' },
    { headerName: '(우선순위 적용) 기타 <4순위>', field: 'etc' },
    { headerName: '(연령기준) 20~29세', field: 'age_20s' },
    { headerName: '(연령기준) 30~39세', field: 'age_30s' },
    { headerName: '(연령기준) 40~49세', field: 'age_40s' },
    { headerName: '(연령기준) 50대이상', field: 'age_over_50' },
    { headerName: '(성별) 남성', field: 'male' },
    { headerName: '(성별) 여성', field: 'female' },
    { headerName: '(창업) 사업자등록완료', field: 'own_bussiness' },
    { headerName: '(고용형태) 정규직', field: 'full_time_contract' },
    { headerName: '(고용형태) 계약직', field: 'contract_worker' },
    { headerName: '(근로시간) 주 40시간 이상', field: 'over_40_week' },
    { headerName: '(근로시간) 주 15 ~ 39시간', field: 'work_15to39_week' },
    { headerName: '(근로시간) 주 15시간 미만', field: 'under_15_week' },
    { headerName: '(4대보험) 전부가입', field: 'full_insurance' },
    { headerName: '(4대보험) 일부가입', field: 'partial_insurance' },
    { headerName: '(4대보험) 미가입', field: 'no_insurance' },
    { headerName: '(계약기간) 정규직(무기계약직)', field: 'indefine_contract' },
    { headerName: '(계약기간) 21개월~30개월(2차 재고용)', field: 'secondary_recontract' },
    { headerName: '(계약기간) 11개월~20개월(1차 재고용)', field: 'first_recontract' },
    { headerName: '(계약기간) 10개월 이내(최초고용)', field: 'first_contract' },
    { headerName: '(ICTSW관련전공여부) 해당없음', field: 'ictswN' },
    { headerName: '(ICTSW관련전공여부) 해당', field: 'ictswY' },
    { headerName: '(전공구분) 인문과학', field: 'humanity_major' },
    { headerName: '(전공구분) 사회과학', field: 'social_science_major' },
    { headerName: '(전공구분) 자연과학', field: 'natural_science_major' },
    { headerName: '(전공구분) 공학', field: 'tech_major' },
    { headerName: '(전공구분) 예체능', field: 'art_major' },
    { headerName: '(전공구분) 기타', field: 'etc_major' },
    { headerName: '(SW강의경험) 없음', field: 'no_sw_experience' },
    { headerName: '(SW강의경험) 1년 미만', field: 'sw_experience_under_year' },
    { headerName: '(SW강의경험) 1년이상 3년미만', field: 'sw_experience_one_to_three' },
    { headerName: '(SW강의경험) 3년이상', field: 'sw_experience_over_three' },
    { headerName: '(기타강의경험) 없음', field: 'no_lec_experience' },
    { headerName: '(기타강의경험) 1년 미만', field: 'lec_experience_under_year' },
    { headerName: '(기타강의경험) 1년이상 3년미만', field: 'lec_experience_one_to_three' },
    { headerName: '(기타강의경험) 3년이상', field: 'lec_experience_over_three' },
    { headerName: '강사 평균 임금(월)', field: 'average_wage' },
]
// 공통 유틸
const ymdToDate = v => {
    if (!v) return null
    const [y, m, d] = String(v).split('T')[0].split('-').map(Number)
    return new Date(y, (m || 1) - 1, d || 1) // 로컬 자정
}

const makeDateComparator = mode => (filterLocalDateAtMidnight, cellValue) => {
    const cellDate = ymdToDate(cellValue)
    if (!cellDate) return mode === 'lte' ? 1 : -1
    if (cellDate < filterLocalDateAtMidnight) return -1
    if (cellDate > filterLocalDateAtMidnight) return 1
    return mode === 'gte' ? 1 : -1 // 같을 때: gte=통과, lte=통과
}

const vfDate = p => (p.value ? String(p.value).split('T')[0] : '')

const baseDateFilterParams = {
    suppressAndOrCondition: true,
    browserDatePicker: true,
    buttons: ['reset'],
}
export const programColDefs = [
    {
        headerName: '연도',
        field: 'registration_year',
        enableRowGroup: true,
        filter: 'agSetColumnFilter',
        filterParams: {
            suppressMiniFilter: false,
        },
    },
    { headerName: '지역', field: 'region_id', enableRowGroup: true },
    { headerName: '프로그램 아이디', field: 'program_id', enableRowGroup: true },
    {
        headerName: '교육 기본 정보',
        children: [
            { headerName: '유형', field: 'education_type' },
            { headerName: '정규구분', field: 'course', enableValue: true, aggFunc: 'count' },
            { headerName: '제목', field: 'program_name', filter: 'agTextColumnFilter', width: 350, flex: 0 },
        ],
    },
    {
        headerName: '프로그램 운영정보',
        children: [
            { headerName: '교육시간 (교시)', field: 'class_hours' },
            { headerName: '교육횟수 (회)', field: 'number_of_session' },
            { headerName: '수강인원(명)', field: 'number_of_applicants', enableValue: true, aggFunc: 'sum' },
            { headerName: '수료인원 (명)', field: 'number_of_graduates', enableValue: true, aggFunc: 'sum' },
            { headerName: '운영상태', field: 'status', enableValue: true, aggFunc: 'sum' },
            { headerName: '아카이브', field: 'is_completed' },
            // 컬럼
            {
                headerName: '교육 시작일',
                field: 'start_date',
                filter: 'agDateColumnFilter',
                width: 200,
                flex: 0,
                filterParams: {
                    ...baseDateFilterParams,
                    filterOptions: ['greaterThan'],
                    defaultOption: 'greaterThan',
                    comparator: makeDateComparator('gte'),
                },
                valueFormatter: vfDate,
            },
            {
                headerName: '교육 종료일',
                field: 'end_date',
                filter: 'agDateColumnFilter',
                width: 200,
                flex: 0,
                filterParams: {
                    ...baseDateFilterParams,
                    filterOptions: ['lessThan'],
                    defaultOption: 'lessThan',
                    comparator: makeDateComparator('lte'),
                },
                valueFormatter: vfDate,
            },
            { headerName: '활동연도', field: 'registration_year' },
            {
                headerName: '주강사',
                field: 'lead_instructors',
                cellRenderer: params => {
                    if (!params.data.tutors) return ''
                    const leadInstructors = params.data.tutors
                        .filter(tutor => tutor.tutor_type === '주강사')
                        .map(tutor => tutor.tutor_name)
                        .join(', ')
                    return leadInstructors
                },
            },
            {
                headerName: '보조강사',
                field: 'assistants',
                cellRenderer: params => {
                    if (!params.data.tutors) return ''
                    const assistants = params.data.tutors
                        .filter(tutor => tutor.tutor_type === '보조강사')
                        .map(tutor => tutor.tutor_name)
                        .join(', ')
                    return assistants
                },
            },
        ],
    },
    {
        headerName: '수요기관',
        children: [
            { headerName: '구분', field: 'category' },
            { headerName: '학년', field: 'grade' },
            { headerName: '학년/반', field: 'classroom' },
            { headerName: '기관명', field: 'organization_name' },
            { headerName: '주소', field: 'address_sido' },
        ],
    },

    {
        headerName: '수요처 담당자',
        children: [
            { headerName: '성명', field: 'manager_name' },
            { headerName: '직위/직책', field: 'manager_position' },
            { headerName: '대표번호', field: 'manager_tel_number' },
            { headerName: '휴대전화', field: 'manager_phone_number' },
            { headerName: '이메일', field: 'manager_email' },
            { headerName: '수요처 특이사항', field: 'manager_remarks' },
        ],
    },
]

export const tutorsColDefs = [
    {
        headerName: '연도',
        field: 'registration_year',
        enableRowGroup: true,
        filter: 'agSetColumnFilter',
        filterParams: {
            suppressMiniFilter: false,
        },
    },
    { headerName: '지역', field: 'region_id' },
    { headerName: '강사 아이디', field: 'tutor_id' },
    {
        headerName: '구분',
        children: [
            { headerName: '고용 여부', field: 'is_employment' },
            { headerName: '청년', field: 'is_youth', cellDataType: 'boolean' },
            { headerName: '전문퇴직자', field: 'is_retiree', cellDataType: 'boolean' },
            { headerName: '경력단절여성', field: 'is_career_gap_female', cellDataType: 'boolean' },
            { headerName: '외국인', field: 'is_foreign', cellDataType: 'boolean' },
            { headerName: '장애여부', field: 'has_disability', cellDataType: 'boolean' },
            { headerName: '보훈여부', field: 'is_veterans', cellDataType: 'boolean' },
            { headerName: '강사등급', field: 'is_advanced_instructor' },
        ],
    },
    {
        headerName: '강사 기본 정보',
        children: [
            { headerName: '성명', field: 'tutor_name' },
            { headerName: '성별', field: 'gender' },
            {
                headerName: '생년월일',
                field: 'resident_num',
                cellClass: 'text-cell',
                // 생년 월일 포매팅
                valueFormatter: params => {
                    if (!params.value) return ''
                    // 하이픈 및 공백 제거
                    let value = String(params.value).replace(/[-\s]/g, '')
                    // 숫자가 아닌 문자 제거
                    value = value.replace(/\D/g, '')
                    // 6자리면 그대로 반환
                    if (value.length === 6) return value
                    // 6자리 이상이면 앞 자리만 노출
                    if (value.length > 6) return value.substring(0, 6)
                    // 그 외의 경우 원본 반환
                    return value
                },
            },
            { headerName: '주소', field: 'sido' },
            { headerName: '연락처', field: 'contact' },
            { headerName: '이메일', field: 'email' },
            { headerName: '기수 (시작년도)', field: 'cohort_start_year' },
            { headerName: '권역', field: 'area_name' },
        ],
    },
    {
        headerName: '활동 정보',
        children: [
            {
                headerName: '계약시작',
                field: 'start_date',
                filter: 'agDateColumnFilter',
                width: 200,
                flex: 0,
                filterParams: {
                    ...baseDateFilterParams,
                    filterOptions: ['greaterThan'],
                    defaultOption: 'greaterThan',
                    comparator: makeDateComparator('gte'),
                },
                valueFormatter: vfDate,
            },
            {
                headerName: '계약만료',
                field: 'end_date',
                filter: 'agDateColumnFilter',
                width: 200,
                flex: 0,
                filterParams: {
                    ...baseDateFilterParams,
                    filterOptions: ['lessThan'],
                    defaultOption: 'lessThan',
                    comparator: makeDateComparator('lte'),
                },
                valueFormatter: vfDate,
            },
            {
                headerName: '활동형태',
                field: 'employment_type',
                valueFormatter: params => {
                    if (params.value === '협동조합') {
                        return '위촉'
                    }
                    return params.value || ''
                },
            },
            { headerName: '활동연도', field: 'registration_year' },
        ],
    },
    {
        headerName: '학력 및 전공',
        children: [
            { headerName: '전공 (학과명)', field: 'major' },
            { headerName: '최종학력', field: 'education_level' },
        ],
    },
    {
        headerName: '자격증 정보',
        children: [
            { headerName: '교원자격보유', field: 'teacher_certification', cellDataType: 'boolean' },
            { headerName: '강의경험 유무', field: 'teaching_experience_yn', cellDataType: 'boolean' },
            { headerName: '자격증', field: 'sw_certification' },
            { headerName: '소프트웨어(SW·AI) 교육강사 자격증', field: 'private_certification' },
            { headerName: '외국어 가능 여부', field: 'is_language', cellDataType: 'boolean' },
            { headerName: '사용 가능한 외국어', field: 'use_language' },
        ],
    },
    {
        headerName: '기타',
        children: [
            { headerName: '자차여부', field: 'own_car_yn', cellDataType: 'boolean' },
            { headerName: '협동조합', field: 'is_cooperative' },
            { headerName: '비고', field: 'is_note' },
        ],
    },
]

export const inventoryColDefs = [
    { headerName: '지역', field: 'region_id', enableRowGroup: true },
    { headerName: '자산 아이디', field: 'tools_id', enableRowGroup: true },
    {
        headerName: '교구재(자산) 정보',
        children: [
            { headerName: '교구재 명', field: 'tools_name' },
            { headerName: '제조사', field: 'manufacturer' },
            { headerName: '모델명', field: 'model_name' },
            { headerName: '취득연월', field: 'acquire_date' },
            { headerName: '단가', field: 'purchase_price' },
            { headerName: '품목분류', field: 'tools_type' },
            { headerName: '자산번호', field: 'tools_num' },
        ],
    },
    {
        headerName: '교구재 현황',
        children: [
            { headerName: '교구재 상태', field: 'tools_state' },
            { headerName: '불량 사유', field: 'defect_reason' },
            { headerName: '수리내역 결과', field: 'repair_result' },
            { headerName: '폐기연월', field: 'dispose_date' },
        ],
    },
    {
        headerName: '기타',
        children: [
            { headerName: '센터명', field: 'center_name' },
            { headerName: '과목(활용)', field: 'subject' },
            { headerName: '비고', field: 'etc' },
        ],
    },
]

export const rentalColDefs = [
    { headerName: '지역', field: 'region_id', enableRowGroup: true },
    { headerName: '대여 아이디', field: 'rental_id', enableRowGroup: true },
    {
        headerName: '교구정보',
        children: [
            { headerName: '품목 (교구명)', field: 'tools_name' },
            { headerName: '자산번호 (제품번호)', field: 'tools_num' },
        ],
    },
    {
        headerName: '대여자 정보',
        children: [{ headerName: '성명 (대여자)', field: 'tutor_name' }],
    },
    {
        headerName: '대여 및 사용정보',
        children: [
            { headerName: '사용기관', field: 'using_institution' },
            { headerName: '대여상태', field: 'rental_status' },
            { headerName: '대여 신청일자', field: 'rental_application_date' },
            { headerName: '대여 일자', field: 'rental_dispatch_date' },
            { headerName: '반납 일자', field: 'rental_return_date' },
            { headerName: '대여/사용목적', field: 'rental_use_purpose' },
        ],
    },
    {
        headerName: '기타',
        children: [
            { headerName: '센터명', field: 'center_name' },
            { headerName: '과목(활용)', field: 'subject' },
            { headerName: '비고', field: 'etc' },
        ],
    },
]
